import { Box, Grid, Typography, Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material'
import {
    ButtonBasic,
    SelectAbiertoCerradoTicket,
    SelectTipoTicket,
    SelectSubTipoTicket,
    SelectMotivoTicket,
    SelectMotivoBajaTk,
    SelectEstadoVencimiento,
    SelectPrioridadTkNubicom,
    SelectNivelAdmTicket,
    SelectStageTicket,
    SelectGrupos,
    DateRange,
} from '../../../components'
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import TuneIcon from '@mui/icons-material/Tune';

const FiltersDialog = ({
    open,
    onClose,
    onApply,
    onClear,
    pendingFilters,
    setPendingFilters,
    onPendingDateChange,
    isDarkMode,
}) => {
    const filterLabelStyle = {
        color: isDarkMode ? '#e0e0e0' : '#2c3e50',
        fontWeight: 600,
        fontSize: 13,
        mb: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 0.5
    };

    const dotStyle = (color) => ({
        width: 6,
        height: 6,
        borderRadius: '50%',
        background: color
    });

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: {
                    background: isDarkMode
                        ? 'linear-gradient(135deg, #1F2A40 0%, #2d3a52 100%)'
                        : 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                    borderRadius: '20px',
                    border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e0e0e0',
                    boxShadow: isDarkMode
                        ? '0 20px 60px rgba(0,0,0,0.6)'
                        : '0 20px 60px rgba(0,0,0,0.15)',
                }
            }}
        >
            <DialogTitle sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                pb: 1,
                borderBottom: isDarkMode ? '1px solid #3d4a62' : '1px solid #e0e0e0',
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Box sx={{
                        width: 40,
                        height: 40,
                        borderRadius: '12px',
                        background: 'linear-gradient(135deg, #0364ff 0%, #4a90e2 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 4px 14px rgba(3, 100, 255, 0.3)',
                    }}>
                        <TuneIcon sx={{ color: '#fff', fontSize: 22 }} />
                    </Box>
                    <Box>
                        <Typography sx={{
                            color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                            fontWeight: 700,
                            fontSize: 18,
                        }}>
                            Filtros de búsqueda
                        </Typography>
                        <Typography sx={{
                            color: isDarkMode ? '#b0bec5' : '#7f8c8d',
                            fontSize: 12,
                        }}>
                            Configura los filtros y presiona Aplicar
                        </Typography>
                    </Box>
                </Box>
                <IconButton onClick={onClose} size="small" sx={{
                    color: isDarkMode ? '#b0bec5' : '#7f8c8d',
                    '&:hover': { background: isDarkMode ? '#3d4a62' : '#f0f0f0' }
                }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ pt: 3, pb: 2 }}>
                <Grid container spacing={2.5} sx={{ mt: 0.5 }}>
                    <Grid item xs={12} sm={6} md={4}>
                        <Box>
                            <Typography sx={filterLabelStyle}>
                                <Box sx={dotStyle('#4caf50')} />
                                Estado
                            </Typography>
                            <SelectAbiertoCerradoTicket
                                isMulti
                                isClearable
                                value={pendingFilters.estado}
                                onChange={(e) => setPendingFilters(prev => ({ ...prev, estado: e?.length ? e.map(o => o.value) : [] }))}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Box>
                            <Typography sx={filterLabelStyle}>
                                <Box sx={dotStyle('#0364ff')} />
                                Etapa
                            </Typography>
                            <SelectStageTicket
                                isMulti
                                isClearable
                                value={pendingFilters.stage}
                                onChange={(e) => setPendingFilters(prev => ({ ...prev, stage: e?.length ? e.map(o => o.value) : [] }))}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Box>
                            <Typography sx={filterLabelStyle}>
                                <Box sx={dotStyle('#ff9800')} />
                                Prioridad
                            </Typography>
                            <SelectPrioridadTkNubicom
                                isMulti
                                isClearable
                                value={pendingFilters.prioridad}
                                onChange={(e) => setPendingFilters(prev => ({ ...prev, prioridad: e?.length ? e.map(o => o.value) : [] }))}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <Box>
                            <Typography sx={filterLabelStyle}>
                                <Box sx={dotStyle('#e91e63')} />
                                Plantilla
                            </Typography>
                            <SelectMotivoTicket
                                isMulti
                                isClearable
                                value={pendingFilters.motivoId}
                                onChange={(e) => setPendingFilters(prev => ({ ...prev, motivoId: e?.length ? e.map(o => o.value) : [] }))}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Box>
                            <Typography sx={filterLabelStyle}>
                                <Box sx={dotStyle('#9c27b0')} />
                                Tipo Ticket
                            </Typography>
                            <SelectTipoTicket
                                isMulti
                                isClearable
                                value={pendingFilters.tipoTicketId}
                                onChange={(e) => setPendingFilters(prev => ({ ...prev, tipoTicketId: e?.length ? e.map(o => o.value) : [] }))}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Box>
                            <Typography sx={filterLabelStyle}>
                                <Box sx={dotStyle('#00bcd4')} />
                                Sub Tipo
                            </Typography>
                            <SelectSubTipoTicket
                                isMulti
                                isClearable
                                value={pendingFilters.subTipoTicketId}
                                onChange={(e) => setPendingFilters(prev => ({ ...prev, subTipoTicketId: e?.length ? e.map(o => o.value) : [] }))}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Box>
                            <Typography sx={filterLabelStyle}>
                                <Box sx={dotStyle('#f44336')} />
                                Vencimiento
                            </Typography>
                            <SelectEstadoVencimiento
                                isMulti
                                isClearable
                                value={pendingFilters.vencimiento}
                                onChange={(e) => setPendingFilters(prev => ({ ...prev, vencimiento: e?.length ? e.map(o => o.value) : [] }))}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Box>
                            <Typography sx={filterLabelStyle}>
                                <Box sx={dotStyle('#795548')} />
                                Motivo Baja
                            </Typography>
                            <SelectMotivoBajaTk
                                isMulti
                                isClearable
                                value={pendingFilters.motivoBajaId}
                                onChange={(e) => setPendingFilters(prev => ({ ...prev, motivoBajaId: e?.length ? e.map(o => o.value) : [] }))}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Box>
                            <Typography sx={filterLabelStyle}>
                                <Box sx={dotStyle('#ff5722')} />
                                Nivel Administrativo
                            </Typography>
                            <SelectNivelAdmTicket
                                isMulti
                                isClearable
                                value={pendingFilters.nivelAdmTkId}
                                onChange={(e) => setPendingFilters(prev => ({ ...prev, nivelAdmTkId: e?.length ? e.map(o => o.value) : [] }))}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Box>
                            <Typography sx={filterLabelStyle}>
                                <Box sx={dotStyle('#3f51b5')} />
                                Grupo
                            </Typography>
                            <SelectGrupos
                                isMulti
                                isClearable
                                allGroup
                                value={pendingFilters.grupoId}
                                onChange={(e) => setPendingFilters(prev => ({ ...prev, grupoId: e?.length ? e.map(o => o.value) : [] }))}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Box>
                            <Typography sx={filterLabelStyle}>
                                <Box sx={dotStyle('#607d8b')} />
                                Rango de Fechas
                            </Typography>
                            <DateRange
                                minDate={new Date('2022-01-01')}
                                onChange={onPendingDateChange}
                                maxDays={180}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{
                px: 3,
                py: 2,
                borderTop: isDarkMode ? '1px solid #3d4a62' : '1px solid #e0e0e0',
                gap: 1,
            }}>
                <ButtonBasic
                    iconStart={<DeleteSweepIcon sx={{ color: isDarkMode ? '#ef9a9a' : '#c62828' }} />}
                    textButton="Limpiar"
                    sx={{
                        height: 40,
                        borderRadius: '10px',
                        fontWeight: 600,
                        fontSize: 13,
                        textTransform: 'none',
                        color: isDarkMode ? '#ef9a9a' : '#c62828',
                        border: isDarkMode ? '1px solid #ef9a9a' : '1px solid #ef5350',
                        background: 'transparent',
                        '&:hover': {
                            background: isDarkMode ? 'rgba(239,154,154,0.1)' : 'rgba(239,83,80,0.08)',
                        },
                        mr: 'auto',
                    }}
                    onClick={onClear}
                    variant='wk'
                    color='nextStep'
                />
                <ButtonBasic
                    textButton="Cancelar"
                    sx={{
                        height: 40,
                        borderRadius: '10px',
                        fontWeight: 600,
                        fontSize: 13,
                        textTransform: 'none',
                        color: isDarkMode ? '#b0bec5' : '#7f8c8d',
                        border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e0e0e0',
                        background: 'transparent',
                        '&:hover': {
                            background: isDarkMode ? '#3d4a62' : '#f0f0f0',
                        },
                    }}
                    onClick={onClose}
                    variant='wk'
                    color='nextStep'
                />
                <ButtonBasic
                    iconStart={<SaveIcon sx={{ color: '#fff' }} />}
                    textButton="Aplicar Filtros"
                    sx={{
                        height: 40,
                        borderRadius: '10px',
                        fontWeight: 600,
                        fontSize: 13,
                        textTransform: 'none',
                        color: '#fff',
                        boxShadow: '0 4px 14px rgba(3, 100, 255, 0.3)',
                    }}
                    onClick={onApply}
                    variant='wk'
                    color='nextStep'
                />
            </DialogActions>
        </Dialog>
    );
};

export default FiltersDialog;
